import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'
import { vfmPlugin } from 'vue-final-modal'
import * as Sentry from '@sentry/vue'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import App from './App.vue'
import router from './router'
import mitt from 'mitt'

import { loadCookiebot } from '@core/cookie-consent'
import { captureCjEvent } from '@core/affiliate-tracking'

loadCookiebot()
captureCjEvent()

const loadOlark = () => {
  const olarkSiteId = import.meta.env.VITE_OLARK_SITE_ID

  if (!olarkSiteId || window.olark) return

  const id = 'olark-loader'
  if (document.getElementById(id)) return
  ;(function (o, l, a, r, k, y) {
    if (o.olark) return
    r = 'script'
    y = l.createElement(r)
    y.id = id
    r = l.getElementsByTagName(r)[0]
    y.async = 1
    y.src = `https://${a}`
    r.parentNode.insertBefore(y, r)
    y = o.olark = function () {
      k.s.push(arguments)
      k.t.push(+new Date())
    }
    y.extend = function (i, j) {
      y('extend', i, j)
    }
    y.identify = function (i) {
      y('identify', (k.i = i))
    }
    y.configure = function (i, j) {
      y('configure', i, j)
      k.c[i] = j
    }
    k = y._ = { s: [], t: [+new Date()], c: {}, l: a }
  })(window, document, 'static.olark.com/jsclient/loader.js')

  window.olark.identify(olarkSiteId)
}

loadOlark()

const emitter = mitt()
const app = createApp(App)

app.config.globalProperties.emitter = emitter

if (import.meta.env.SENTRY_AUTH_TOKEN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
    tracePropagationTargets: [import.meta.env.VITE_APP_URL].filter(Boolean),
  })
}

app.use(vfmPlugin)
app.use(router)
app.use(Toast)
const pinia = createPinia()

pinia.use(({ store }) => {
  store['router'] = markRaw(router)
})

app.use(pinia)

app.mount('#app')
